/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sparkling_Blue_Otter_JumpInputs */

const en_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready to activate`)
};

const id_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siap diaktifkan`)
};

const ms_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedia untuk diaktifkan`)
};

const ca_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Llest per activar`)
};

const cs_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připraveno k aktivaci`)
};

const da_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klar til aktivering`)
};

const de_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereit zur Aktivierung`)
};

const et_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiveerimiseks valmis`)
};

const es_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listo para activar`)
};

const fr_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prêt à activer`)
};

const hr_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spremno za aktivaciju`)
};

const it_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronto per l'attivazione`)
};

const lv_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gatavs aktivizēšanai`)
};

const lt_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paruošta aktyvuoti`)
};

const hu_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Készen áll az aktiválásra`)
};

const nl_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klaar om te activeren`)
};

const nb_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klar til aktivering`)
};

const pl_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gotowe do aktywacji`)
};

const pt_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronto para ativar`)
};

const ro_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gata de activare`)
};

const sk_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pripravené na aktiváciu`)
};

const sl_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pripravljeno za aktivacijo`)
};

const fi_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valmis aktivoitavaksi`)
};

const sv_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redo att aktiveras`)
};

const vi_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sẵn sàng kích hoạt`)
};

const tr_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinleştirmeye hazır`)
};

const el_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Έτοιμο για ενεργοποίηση`)
};

const bg_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Готово за активиране`)
};

const ru_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Готов к активации`)
};

const sr_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спремно за активацију`)
};

const uk_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Готово до активації`)
};

const ka_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`მზადაა გასააქტიურებლად`)
};

const hi_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सक्रिय करने के लिए तैयार`)
};

const th_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`พร้อมเปิดใช้งาน`)
};

const ko_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`활성화 준비 완료`)
};

const zh_tw_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`準備啟用`)
};

const ja_sparkling_blue_otter_jump = /** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクティベート準備完了`)
};

/** @type {(inputs: Sparkling_Blue_Otter_JumpInputs) => LocalizedString} */
const zh_sparkling_blue_otter_jump = en_sparkling_blue_otter_jump;

/**
* | output |
* | --- |
* | "Ready to activate" |
*
* @param {Sparkling_Blue_Otter_JumpInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const sparkling_blue_otter_jump = /** @type {((inputs?: Sparkling_Blue_Otter_JumpInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sparkling_Blue_Otter_JumpInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sparkling_blue_otter_jump(inputs)
	if (locale === "ms") return ms_sparkling_blue_otter_jump(inputs)
	if (locale === "ca") return ca_sparkling_blue_otter_jump(inputs)
	if (locale === "cs") return cs_sparkling_blue_otter_jump(inputs)
	if (locale === "da") return da_sparkling_blue_otter_jump(inputs)
	if (locale === "de") return de_sparkling_blue_otter_jump(inputs)
	if (locale === "et") return et_sparkling_blue_otter_jump(inputs)
	if (locale === "es") return es_sparkling_blue_otter_jump(inputs)
	if (locale === "fr") return fr_sparkling_blue_otter_jump(inputs)
	if (locale === "hr") return hr_sparkling_blue_otter_jump(inputs)
	if (locale === "it") return it_sparkling_blue_otter_jump(inputs)
	if (locale === "lv") return lv_sparkling_blue_otter_jump(inputs)
	if (locale === "lt") return lt_sparkling_blue_otter_jump(inputs)
	if (locale === "hu") return hu_sparkling_blue_otter_jump(inputs)
	if (locale === "nl") return nl_sparkling_blue_otter_jump(inputs)
	if (locale === "nb") return nb_sparkling_blue_otter_jump(inputs)
	if (locale === "pl") return pl_sparkling_blue_otter_jump(inputs)
	if (locale === "pt") return pt_sparkling_blue_otter_jump(inputs)
	if (locale === "ro") return ro_sparkling_blue_otter_jump(inputs)
	if (locale === "sk") return sk_sparkling_blue_otter_jump(inputs)
	if (locale === "sl") return sl_sparkling_blue_otter_jump(inputs)
	if (locale === "fi") return fi_sparkling_blue_otter_jump(inputs)
	if (locale === "sv") return sv_sparkling_blue_otter_jump(inputs)
	if (locale === "vi") return vi_sparkling_blue_otter_jump(inputs)
	if (locale === "tr") return tr_sparkling_blue_otter_jump(inputs)
	if (locale === "el") return el_sparkling_blue_otter_jump(inputs)
	if (locale === "bg") return bg_sparkling_blue_otter_jump(inputs)
	if (locale === "ru") return ru_sparkling_blue_otter_jump(inputs)
	if (locale === "sr") return sr_sparkling_blue_otter_jump(inputs)
	if (locale === "uk") return uk_sparkling_blue_otter_jump(inputs)
	if (locale === "ka") return ka_sparkling_blue_otter_jump(inputs)
	if (locale === "hi") return hi_sparkling_blue_otter_jump(inputs)
	if (locale === "th") return th_sparkling_blue_otter_jump(inputs)
	if (locale === "ko") return ko_sparkling_blue_otter_jump(inputs)
	if (locale === "zh") return zh_sparkling_blue_otter_jump(inputs)
	if (locale === "zh-tw") return zh_tw_sparkling_blue_otter_jump(inputs)
	if (locale === "ja") return ja_sparkling_blue_otter_jump(inputs)
	return en_sparkling_blue_otter_jump(inputs)
});